import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.badasolution.in';

const getHeaders = () => {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
        'Content-Type': 'application/json'
    };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

export async function getWebsiteLeadIntegration() {
    try {
        const response = await axios.get(`${API_BASE}/api/public-leads/integration`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch website lead integration settings');
    }
}

export async function updateWebsiteLeadIntegration(payload) {
    try {
        const response = await axios.patch(`${API_BASE}/api/public-leads/integration`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to update website lead integration settings');
    }
}

export async function regenerateWebsiteLeadKey() {
    try {
        const response = await axios.post(`${API_BASE}/api/public-leads/integration/regenerate-key`, {}, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to regenerate website lead API key');
    }
}
